import React, { useState } from "react";
import styles from "@/styles/detail/DetailBookingSidebar/RoomTravellersSection.module.scss";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";

const RowTravellerSectionDetail = ({
    title,
    addMethod,
    minusMethod,
    showValue,
    disableMinus,
    disablePlus,
    textPopover,
    textPopoverPlus,
    colorRow,
}: {
    title: string;
    showValue: number;
    addMethod: () => void;
    minusMethod: () => void;
    disableMinus: boolean;
    disablePlus?: boolean;
    textPopover: string;
    textPopoverPlus?: string;
    colorRow?: boolean;
}) => {
    const { PlusCircle, MinusCircle } = userInterfaceSvg;

    const [click, setClick] = useState<boolean>(false);

    return (
        <div
            className={`mb-3 p-1 d-flex flex-row justify-content-between ${
                colorRow ? `${styles.containerTravellersRowEccesso}` : ""
            }`}
        >
            <div className="align-middle w-100">
                <p className={styles.containerTravellersText}>{title}</p>
            </div>
            <div className="d-flex justify-content-end w-100">
                <div
                    className="d-flex flex-row justify-content-end"
                    style={{ gap: 8 }}
                >
                    <div
                        className={`p-0 d-flex flex-row gap-2 justify-content-end ${
                            disableMinus ? styles.disableButton : "p-0"
                        }`}
                        onClick={() => {
                            if (!disableMinus) {
                                minusMethod();
                            } else {
                                setClick(disableMinus && !click);
                            }
                        }}
                        style={{ position: "relative" }}
                        onMouseEnter={() => {
                            setClick(disableMinus && !click);
                        }}
                        onMouseLeave={() => setClick(false)}
                    >
                        {disableMinus && click && (
                            <div className={styles.popoverContainer}>
                                <div className={styles.popoverContainerArrow} />
                                <span className={styles.popoverContainerText}>
                                    {`${textPopover}`}
                                </span>
                            </div>
                        )}

                        <MinusCircle />
                    </div>
                    <div className="p-0" style={{ width: "15px" }}>
                        <p className={styles.containerTravellersNumber}>
                            {showValue}
                        </p>
                    </div>
                    <div
                        className={`p-0 d-flex flex-row gap-2 justify-content-end ${
                            disablePlus ? styles.disableButton : "p-0"
                        }`}
                        onClick={() => {
                            if (!disablePlus) {
                                addMethod();
                            }
                            setClick(
                                disablePlus ? disablePlus && !click : false
                            );
                        }}
                        style={{ position: "relative" }}
                        onMouseEnter={() => {
                            setClick(
                                disablePlus ? disablePlus && !click : false
                            );
                        }}
                        onMouseLeave={() => setClick(false)}
                    >
                        {disablePlus && click && (
                            <div className={styles.popoverContainer}>
                                <div className={styles.popoverContainerArrow} />
                                <span className={styles.popoverContainerText}>
                                    {`${textPopoverPlus}`}
                                </span>
                            </div>
                        )}
                        <PlusCircle />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RowTravellerSectionDetail;
